"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExportTaskProducts = void 0;
const use_export_product_presentations_hook_1 = require("../../../../../common/product-table/hooks/use-export-product-presentations.hook");
const task_view_1 = require("../../../../../store/catalogs/task-view");
const store_1 = require("../../../../../../store");
const useExportTaskProducts = ({ catalogId, dynamicColumns, productTreeNodeId, reviewStatus, }) => {
    const tableFilter = (0, task_view_1.useTaskViewProductsTableFilter)();
    const tableSearch = (0, task_view_1.useTaskViewProductsTableSearch)();
    const tableSort = (0, task_view_1.useTaskViewProductsTableSort)();
    const productTreeId = (0, store_1.useProductTreeId)();
    const visibleDynamicColumns = {
        columnsOrder: dynamicColumns.columnsOrder.filter((col) => (dynamicColumns.selectAllMode
            ? !dynamicColumns.excludedColumns.includes(col)
            : dynamicColumns.excludedColumns.includes(col))),
    };
    return (0, use_export_product_presentations_hook_1.useExportProductPresentations)({
        catalogId,
        productTreeId,
        productTreeNodeIds: [productTreeNodeId],
        tableFilter,
        tableSearch,
        tableSort,
        dynamicColumns: visibleDynamicColumns,
        reviewStatus,
    });
};
exports.useExportTaskProducts = useExportTaskProducts;
